import {
  ContentLayout,
  Container,
  Header,
  Link,
  Cards,
  Box,
  TextContent,
  SpaceBetween,
} from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';
import routePaths from 'src/contstant/routePaths';
import { TbClipboardList } from 'react-icons/tb';
import { TbSettings2 } from 'react-icons/tb';
import { GoHome } from 'react-icons/go';
import { GoQuestion } from 'react-icons/go';
import { GoTasklist } from 'react-icons/go';
import { GoDownload } from 'react-icons/go';
import { GoCommentDiscussion } from 'react-icons/go';
import { LiaUserShieldSolid } from 'react-icons/lia';
import { LiaObjectUngroupSolid } from 'react-icons/lia';
import { AiOutlineUsergroupAdd } from 'react-icons/ai';
import { MdOutlineAddLocationAlt } from 'react-icons/md';
import { BsTags } from 'react-icons/bs';
import { GrTemplate } from 'react-icons/gr';
import { RiFolderUnknowLine } from 'react-icons/ri';
import { IoSettingsOutline } from 'react-icons/io5';
import { IoCalendarOutline } from 'react-icons/io5';
import { IconType } from 'react-icons';
import { useUserDetails } from 'src/providers/UserProvider';
import permissionAccessConfig from 'src/contstant/permissionAccessConfig';
import { useFeatureFlags } from 'src/context/FeatureFlagsContext';
const SettingsPage = () => {
  const navigate = useNavigate();
  const { permissions } = useUserDetails();
  const { enableDivisionalConfiguration } = useFeatureFlags();
  const canExportFeedback = permissions.has(
    permissionAccessConfig.FEEDBACK.EXPORT_FEEDBACK,
  );
  // Define the type for card items
  type CardItem = {
    name: string;
    icon: React.ComponentType;
    path: string;
  };
  const cardItems: CardItem[] = [
    {
      name: routePaths.ROLES_PERMISSIONS.title,
      icon: LiaUserShieldSolid,
      path: routePaths.ROLES_PERMISSIONS.path,
    },
    {
      name: routePaths.BUSINESS_UNITS_DIVISIONS.title,
      path: routePaths.BUSINESS_UNITS_DIVISIONS.path,
      icon: LiaObjectUngroupSolid,
    },
    {
      name: routePaths.USERS.title,
      path: routePaths.USERS.path,
      icon: AiOutlineUsergroupAdd,
    },
    {
      name: routePaths.LOCATIONS.title,
      path: routePaths.LOCATIONS.path,
      icon: MdOutlineAddLocationAlt,
    },
    {
      name: routePaths.TAGS.title,
      path: routePaths.TAGS.path,
      icon: BsTags,
    },
    {
      name: routePaths.CATEGORIES.title,
      path: routePaths.CATEGORIES.path,
      icon: RiFolderUnknowLine,
    },
    {
      name: routePaths.TEMPLATE.title,
      path: routePaths.TEMPLATE.path,
      icon: GrTemplate,
    },
    {
      name: routePaths.SCHEDULES.title,
      path: routePaths.SCHEDULES.path,
      icon: IoCalendarOutline,
    },
    // Divisional configuration is feature-flag gated and requires division-edit permission.
    ...(enableDivisionalConfiguration &&
    permissions.has(permissionAccessConfig.DIVISION.EDIT_DIVISION)
      ? [
          {
            name: routePaths.CONFIGURATION.title,
            path: routePaths.CONFIGURATION.path,
            icon: TbSettings2,
          },
        ]
      : []),
    // Feedback export is permission-gated; only show the tile when the user can export.
    ...(canExportFeedback
      ? [
          {
            name: routePaths.FEEDBACK.title,
            path: routePaths.FEEDBACK.path,
            icon: GoCommentDiscussion,
          },
        ]
      : []),
  ];
  return (
    <ContentLayout
      data-testid="settings-content-layout"
      header={
        <Header data-testid="settings-header" variant="h3">
          Settings
        </Header>
      }
    >
      <Cards<CardItem>
        data-testid="settings-cards"
        items={cardItems}
        cardDefinition={{
          header: (item) => {
            const IconComponent = item.icon as IconType;
            return (
              <Box textAlign="center" padding="l">
                <div
                  data-testid={`settings-card-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate(item.path)}
                >
                  <IconComponent
                    data-testid={`settings-icon-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                    size={24}
                  />
                  <TextContent
                    data-testid={`settings-text-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <strong style={{ cursor: 'pointer' }}>{item.name}</strong>
                  </TextContent>
                </div>
              </Box>
            );
          },
        }}
        // Optional: Define how many cards per row
        cardsPerRow={[{ cards: 1 }, { minWidth: 500, cards: 4 }]}
      />
    </ContentLayout>
  );
};
export default SettingsPage;
